import React, { useState } from "react";
import { LessonMetadata } from "./lesson-information-modal-types";
import "./details.scss";

const getPlacementGrade = (grades: number[]): string => {
  var result: string = "";
  var separator: string = "";
  grades?.forEach((grade) => {
    result = `${result}${separator}${grade == 0 ? "K" : grade}`;
    separator = ",";
  });
  return result;
};

const getLessonInfoBoxes = (lessonMetadata: LessonMetadata) => {
  const { skillLevel, placementGrade, subjectId, appropriateGrades } = lessonMetadata;

  let boxes = [
    {
      name: "skillLevel",
      text: `${skillLevel} skill level`
    },
    {
      name: "grade",
      text: `Grade ${getPlacementGrade(placementGrade)} lesson`
    }
  ];

  if (subjectId.toLocaleLowerCase() !== "science") {
    boxes.push({
      name: "appropriateFor",
      text: `Appropriate for grades ${appropriateGrades}`
    });
  }

  return boxes;
};

interface IDetailsProps {
  lessonMetadata: LessonMetadata;
  fromAssignmentBuilder: boolean;
}

const Details = (props: IDetailsProps) => {
  const { description, domain } = props.lessonMetadata;
  const { lessonMetadata, fromAssignmentBuilder } = props;
  const [lessonInfoBoxes, setLessonInfoBoxes] = useState(
    fromAssignmentBuilder ? getLessonInfoBoxes(lessonMetadata) : []
  );

  return (
    <div className="details">
      <h2 className="subtitle">Overview</h2>
      <p className="description">{description}</p>
      {fromAssignmentBuilder && (
        <div className="boxes">
          {lessonInfoBoxes.map((value, key) => {
            return (
              <div className="box" key={key}>
                {value.text}
              </div>
            );
          })}
        </div>
      )}
      {!!domain && (
        <div className="domain">
          <h2 className="subtitle">Domain</h2>
          <p className="description">{domain}</p>
        </div>
      )}
    </div>
  );
};
export default Details;
